
import { defineComponent } from 'vue'

import Flex from '@/components/layout/Flex.vue'

export default defineComponent({
	name: 'Overlay',

	components: {
		Flex
	},

	props: {
		value: Boolean 
	}
})
